export default "__VITE_ASSET__Fw_C$7gz__"